<div class="modal-header">
  <h5 class="modal-title mb-0 sd-text-primary">Menu List</h5>
  <button type="button" class="btn-close custom-close-btn" aria-label="Close" (click)="closeModal()"></button>
</div>

<div class="modal-body bg-light">
  <div class="card shadow-sm border-0">
    <div class="card-body text-center">
      <h6 class="text-secondary mb-4">Search Results:</h6>
      <ng-container *ngFor="let menu of filteredMenus">
        <div class="mb-3">
          <!-- Main Menu Button -->
          <button type="button" class="btn btn-outline-primary rounded-pill px-3 py-2" [disabled]="!menu.url"
            (click)="navigate(menu)">
            Main - {{ menu.title }}
          </button>
          <!-- 🔹 Level 1 Submenu -->
          <div *ngIf="menu.submenu?.length" class="mt-2">
            <ng-container *ngFor="let sub of menu.submenu">
              <div class="mb-2">
                <button type="button" class="btn btn-outline-info rounded-pill px-3 py-2" [disabled]="!sub.url"
                  (click)="navigate(sub)">
                  Sub → {{ sub.title }}
                </button>
                <!-- 🔹 Level 2 Submenu -->
                <div *ngIf="sub.submenu?.length" class="mt-2">
                  <button *ngFor="let child of sub.submenu" type="button"
                    class="btn btn-outline-secondary rounded-pill px-3 py-2" (click)="navigate(child)">
                    Child → {{ child.title }}
                  </button>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>